import ProjectForm from "$containers/Projects/ProjectForm";
import useProjectForm from "$hooks/useProjectForm";

export const PopinProject = ({ togglePopin }: any) => {
  const {
    error: errorProject,
    handleSubmit: handleSubmitProject,
    submitting: submittingProject,
  } = useProjectForm(undefined, togglePopin);

  return (
    <ProjectForm
      onSubmit={handleSubmitProject}
      projectError={errorProject}
      onReset={togglePopin}
      isSubmitting={submittingProject}
    />
  );
};
